import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { QuestionCatalogItem, QuestionPoolDetail, QuestionPoolSummary, UpsertQuestionRequest } from '../models/question-catalog.model';

import { appEnvironment } from '../app-environment';

@Injectable({ providedIn: 'root' })
export class QuestionCatalogService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${appEnvironment.apiBaseUrl}/question-catalog`;

  getPools(): Observable<QuestionPoolSummary[]> {
    return this.http.get<QuestionPoolSummary[]>(`${this.apiUrl}/pools`);
  }

  getPoolDetail(poolId: string): Observable<QuestionPoolDetail> {
    return this.http.get<QuestionPoolDetail>(`${this.apiUrl}/pools/${poolId}`);
  }

  createQuestion(poolId: string, data: Record<string, unknown>): Observable<QuestionCatalogItem> {
    const request: UpsertQuestionRequest = { data };
    return this.http.post<QuestionCatalogItem>(`${this.apiUrl}/pools/${poolId}/questions`, request);
  }

  updateQuestion(poolId: string, questionId: number, data: Record<string, unknown>): Observable<QuestionCatalogItem> {
    const request: UpsertQuestionRequest = { data };
    return this.http.put<QuestionCatalogItem>(`${this.apiUrl}/pools/${poolId}/questions/${questionId}`, request);
  }
}
